





















































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitaisRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteHospitaisRemuneracaoStore'
import EventBus from '@/plugins/EventBus'
import { maskCPFCNPJ, maskDate } from '@/utils/common'
import ModalRemuneracaoAddGrupoRepasse from './ModalRemuneracaoAddGrupoRepasse.vue'

@Component({
  components: {
    ModalRemuneracaoAddGrupoRepasse,
  },
})
export default class ModalCadastroGrupoRepasse extends Vue {
  loadHospitais: boolean = false
  loadAddHospital: boolean = false
  loadEditHospital: string = ''
  loadDelete: boolean = false
  search: string = ''
  showModalDelete: boolean = false

  get getSuporteHospitaisRemuneracaoStore() {
    return getModule(SuporteHospitaisRemuneracaoStore, this.$store)
  }

  get getGrupo() { return this.getSuporteHospitaisRemuneracaoStore.grupoRepasse }

  get loadingAddHospital() { return this.loadAddHospital }
  set loadingAddHospital(value: boolean) { this.loadAddHospital = value }

  get loadingDelete() { return this.loadDelete }
  set loadingDelete(value: boolean) { this.loadDelete = value }

  get loadingEditHospital() { return this.loadEditHospital }
  set loadingEditHospital(value: string) { this.loadEditHospital = value }

  get loadingHospitais() { return this.loadHospitais }
  set loadingHospitais(value: boolean) { this.loadHospitais = value }

  get headers() {
    return [
      { text: 'Nome grupo repasse', class: 'table-headers', align: 'left', value: 'grupoRepasseNome' },
      { text: 'Nome hospital', class: 'table-headers', align: 'left', value: 'hospitalNome' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModal() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.grupoRepasse
  }

  set showModal(value: boolean) {
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'grupoRepasse', value })
  }

  maskCnpj(cnpj: string) {
    return maskCPFCNPJ(cnpj)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async addGrupoRepasse() {
    this.loadingAddHospital = true
    this.getSuporteHospitaisRemuneracaoStore.setMode({ mode: 'CREATE' })
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'addOrEditGrupoRepasse', value: true })
    this.loadingAddHospital = false
  }

  async editarHospital(item: any) {
    this.loadingEditHospital = item.id
    this.getSuporteHospitaisRemuneracaoStore.setMode({ mode: 'EDIT' })
    this.getSuporteHospitaisRemuneracaoStore.setItemGrupoRepasse(item)
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'addOrEditGrupoRepasse', value: true })
    this.loadingEditHospital = ''
  }

  openModalDelete(item: any) {
    this.getSuporteHospitaisRemuneracaoStore.setGrupoRepasseId(item.grupoRepasseId)
    this.getSuporteHospitaisRemuneracaoStore.setHospitalId(item.hospitalId)
    this.showModalDelete = true
  }

  closeModalDelete() {
    this.showModalDelete = false
  }

  async deleteItem() {
    this.loadingDelete = true
    const response = await this.getSuporteHospitaisRemuneracaoStore.deleteGrupoRepasse()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item excluído com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getSuporteHospitaisRemuneracaoStore.getGrupoRepasse()
      this.closeModalDelete()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível excluir o item!', icon: 'warning', color: '#C62828' })
    }
    this.loadingDelete = false
  }

  async closeModal() {
    await this.getSuporteHospitaisRemuneracaoStore.getGrupoHospital()
    this.getSuporteHospitaisRemuneracaoStore.clearHospitaisDetails()
    this.showModal = false
  }
}
